// extracted by extract-css-chunks-webpack-plugin
module.exports = {"accordion":"_1PKby_","expandIcon":"J42ZcX"};